import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllergiesExamsDiseasesAction } from "../actions";
import { getLoading, getData } from "../selectors";
import { getAppColor } from "@icarius-app/selectors";
import { Grid } from "@material-ui/core";
import DataItem from "./data/dataItem";
import { RESET_STATE } from "../actionTypes";
import ABMLayout from "@icarius-common/abmComponents/abmLayout";
import paths from "@icarius-router/paths";
import { useLocation } from "react-router-dom";
import { getLocalizedString } from "@icarius-localization/strings";

export const TypeContext = React.createContext("");

const AllergiesExamsDiseases = ({ history }) => {
    const [createIsOpen, setCreateIsOpen] = useState(false);

    const location = useLocation();
    const dispatch = useDispatch();

    const getTypeString = () => {
        return location.pathname === paths.allergiesSettings
            ? "alergia"
            : location.pathname === paths.examsSettings
            ? "exámen médico"
            : "enfermedad";
    };

    const type =
        location.pathname === paths.allergiesSettings ? "A" : location.pathname === paths.examsSettings ? "E" : "D";

    const color = useSelector(getAppColor);
    const data = useSelector(getData);
    const isLoading = useSelector(getLoading);

    useEffect(() => {
        dispatch(getAllergiesExamsDiseasesAction(type));
        return () => {
            dispatch({ type: RESET_STATE });
        };
    }, [dispatch, type]);

    const getDataIsEmpty = () => {
        return !data || data.length === 0;
    };

    return (
        <TypeContext.Provider value={{ type, getTypeString }}>
            <ABMLayout
                title={
                    type === "E"
                        ? getLocalizedString("medicalExamsDefinition")
                        : getLocalizedString("definitionTypeOf", { type: getTypeString() })
                }
                isLoading={isLoading}
                showCreateButton={!createIsOpen}
                createButtonTitle={getLocalizedString("newTypeOf", { type: getTypeString() })}
                createButtonOnClick={() => setCreateIsOpen(true)}
                showGoBack
                handleGoBack={() => history.push(paths.allergiesExamsAndDiseases)}
                showNoData={getDataIsEmpty()}
                noDataTitle={getLocalizedString("noFoundTypeOf", { type: getTypeString() })}
                noDataCreateTitle={getLocalizedString("newTypeOf", { type: getTypeString() })}
                noDataOnClick={() => setCreateIsOpen(true)}
            >
                <Grid container item xs={12} direction="row">
                    {createIsOpen && (
                        <Grid container item xs={12} style={{ margin: "10px 0px" }}>
                            <DataItem color={color} data={null} closeNew={() => setCreateIsOpen(false)} />
                        </Grid>
                    )}
                    {data &&
                        data.map((item) => {
                            return (
                                <Grid container item xs={12} style={{ margin: "10px 0px" }} key={item.code}>
                                    <DataItem data={item} color={color} />
                                </Grid>
                            );
                        })}
                </Grid>
            </ABMLayout>
        </TypeContext.Provider>
    );
};

export default AllergiesExamsDiseases;
